module.exports = __webpack_public_path__ + "img/gift-box.c0d6e12b.webp";